import LocationSearchingIcon from '@mui/icons-material/LocationSearching';
import IconButton from '@mui/material/IconButton';
import PropTypes from 'prop-types';
import { Fragment, useState } from 'react';
import Dialog from '/@/components/dialog';
import { _ } from '/@/locale';

/** @param {typeof propTypes} props  */
function DeviceLocation(props) {
    const [state, setState] = useState({
        loading: false,
        showDialog: false,
    });

    function getPosition() {
        return new Promise((resolve) => {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    resolve([position.coords.longitude, position.coords.latitude]);
                },
                () => {
                    setState((prev) => ({ ...prev, showDialog: true }));
                    resolve();
                },
                { timeout: 10000 }
            );
        });
    }

    async function run() {
        setState((prev) => ({ ...prev, loading: true }));
        const position = await getPosition();
        if (position) {
            props.onResult(position);
            if (props.trackEvent) props.trackEvent({ key: 'fields.geolocateDevice' });
        } else if (props.trackEvent) {
            props.trackEvent({ key: 'fields.geolocateDeviceError' });
        }
        setState((prev) => ({ ...prev, loading: false }));
    }

    function handleDialogClose() {
        setState((prev) => ({ ...prev, showDialog: false }));
    }

    if (!navigator.geolocation) return null;

    return (
        <Fragment>
            <Dialog
                title={_('Error')}
                message={_('Error obteniendo ubicación. Verificá que el GPS esté prendido.')}
                visible={state.showDialog}
                onClose={handleDialogClose}
                onAccept={handleDialogClose}
            />
            <IconButton
                disabled={state.loading}
                onClick={run}
                color='gray'
                sx={{ backgroundColor: 'white !important', mx: 1, p: 1 }}
                size='small'
            >
                <LocationSearchingIcon sx={{ width: '20px !important' }} fontSize='small' />
            </IconButton>
        </Fragment>
    );
}

const propTypes = {
    onResult: PropTypes.func.isRequired,
    trackEvent: PropTypes.func,
};

DeviceLocation.propTypes = propTypes;

export default DeviceLocation;
